var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryCat11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.008,
    height: 29.008,
    viewBox: "0 0 29.008 29.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "inventory_2_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24_1_",
    "data-name": "inventory_2_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24 (1)",
    d: "M104.287-830.992a2.66,2.66,0,0,1-1.951-.809,2.66,2.66,0,0,1-.809-1.951v-17.1a2.91,2.91,0,0,1-1.1-.985,2.586,2.586,0,0,1-.427-1.473v-3.934a2.66,2.66,0,0,1,.809-1.951A2.66,2.66,0,0,1,102.76-860h23.488a2.66,2.66,0,0,1,1.951.809,2.66,2.66,0,0,1,.809,1.951v3.934a2.586,2.586,0,0,1-.427,1.473,2.91,2.91,0,0,1-1.1.985v17.1a2.66,2.66,0,0,1-.809,1.951,2.66,2.66,0,0,1-1.951.809Zm-1.527-21.844h23.488a.458.458,0,0,0,.338-.132.458.458,0,0,0,.132-.338v-3.934a.457.457,0,0,0-.132-.338.457.457,0,0,0-.338-.132H102.76a.457.457,0,0,0-.338.132.457.457,0,0,0-.132.338v3.934a.458.458,0,0,0,.132.338A.458.458,0,0,0,102.76-852.836Zm7.457,9.528h8.573V-845.5h-8.573Z",
    transform: "translate(-100 860)",
    fill: "#85899c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryCat11);
export default __webpack_public_path__ + "static/media/inventory_cat_11.9d172ef34b6c76d9cc14c736e37331c4.svg";
export { ForwardRef as ReactComponent };